import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const fromUrl = new URLSearchParams(window.location.search).get('lang');
    if (['sl', 'en', 'it'].includes(fromUrl)) return fromUrl;
    return localStorage.getItem('language') || 'sl';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => {
      if (prev === 'sl') return 'en';
      if (prev === 'en') return 'it';
      return 'sl';
    });
  }, []);

  const t = useCallback((obj) => {
    if (typeof obj === 'string') return obj;
    return obj[language] || obj['sl'] || '';
  }, [language]);

  const value = useMemo(
    () => ({ language, toggleLanguage, setLanguage, t }),
    [language, toggleLanguage, t]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
